var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"login clearfix"},[_c('div',{staticClass:"login-image",class:[_vm.studio]},[_vm._m(0)]),_c(_vm.currentView,{tag:"component",attrs:{"user":_vm.user},on:{"update:view":_vm.updateCurrentView,"update:user":_vm.updateUser}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"login-image-title"},[_c('h2',[_vm._v("Log in")])])
}]

export { render, staticRenderFns }